import React from 'react';
import { difference } from 'lodash';
import { redirectTo } from '../../../utils/redirect';
import { Dropdown, Form } from '../../ui-kit';
import { IconCaretDown, IconPlus, IconDisplay, IconDashboard } from '../../ui-kit/icons';
import { isDesktop } from 'react-device-detect';

const PlainToggle = React.forwardRef(({ children, onClick }, ref) => (
  <h3
    className="d-inline-block"
    style={{ cursor: 'pointer' }}
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children} <IconCaretDown />
  </h3>
));
PlainToggle.displayName = 'PlainToggle';

const DashboardDropdownItem = ({ dashboard, redirectToDashboard }) => (
  <Dropdown.Item
    key={dashboard.id}
    eventKey={dashboard.id}
    onClick={() => redirectToDashboard(dashboard.group_id, dashboard.id)}
  >
    <div className="d-flex justify-content-between">
      {dashboard.title}
      <span>
        {dashboard.default && <IconDashboard className="ms-2" title={I18n.t('dashboards.default')} />}
        {dashboard.default_for_station_monitor && (
          <IconDisplay className="ms-2" title={I18n.t('dashboards.default_for_station_monitor')} />
        )}
      </span>
    </div>
  </Dropdown.Item>
);

const DashboardSelector = props => {
  const groupDashboards = props.dashboards.filter(d => !d.personal);
  const userDashboards = difference(props.dashboards, groupDashboards);

  const redirectToDashboard = (groupId, dashboardId) => {
    const url = `/groups/${groupId}/dashboards/${dashboardId}`;
    redirectTo(url);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle as={PlainToggle}>{props.currentDashboard.title}</Dropdown.Toggle>

      <Dropdown.Menu>
        {groupDashboards.map(dashboard => (
          <DashboardDropdownItem key={dashboard.id} dashboard={dashboard} redirectToDashboard={redirectToDashboard} />
        ))}
        {userDashboards.length > 0 && <Dropdown.Divider />}
        {userDashboards.map(dashboard => (
          <DashboardDropdownItem key={dashboard.id} dashboard={dashboard} redirectToDashboard={redirectToDashboard} />
        ))}
        {isDesktop && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => props.showNewDashboardModal(true)}>
              <IconPlus /> {I18n.t('dashboards.new_dashboard')}
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const DashboardTitle = ({
  editMode,
  dashboardTitle,
  accessibleDashboards,
  currentDashboard,
  showNewDashboardModal,
  groupDashboardEditRights,
  updateTitle
}) => {
  return editMode ? (
    <Form.Control value={dashboardTitle} onChange={e => updateTitle(e.target.value)} />
  ) : (
    <DashboardSelector
      dashboards={accessibleDashboards}
      currentDashboard={currentDashboard}
      showNewDashboardModal={showNewDashboardModal}
      groupDashboardEditRights={groupDashboardEditRights}
    />
  );
};

export default DashboardTitle;
